<template>
  <div>
    <div :id="id" :style="{height: '400px'}"></div>
  </div>
</template>
<script>
import echarts from 'echarts'
export default {
  props: {
    id: {
      type: String,
      default: () => ''
    },
    data: {
      type: Array,
      default: () => []
    },
    abscissaHis: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    data: {
      handler(newValue) {
        this.drawLine(newValue)
      },
      immediate: false,
    },
  },
  methods: {
    drawLine (data) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById(this.id))
      // 绘制图表
      myChart.setOption({
          title: {
            text: '营业额统计图'
          },
          color: ['#3398DB'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: this.abscissaHis,
              axisTick: {
                  alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                formatter: `{value}万元`
              }
            }
          ],
          series: [
            {
              name: '销售额',
              type: 'bar',
              barWidth: '20%',
              data: data
            }
          ]
      })
    }
  }
}
</script>
<style scoped lang="less">

</style>